export var computeItemHeight = function (treeId) {
    var _a;
    var firstItem = document.querySelector("[data-rct-tree=\"".concat(treeId, "\"] [data-rct-item-container=\"true\"]"));
    return (_a = firstItem === null || firstItem === void 0 ? void 0 : firstItem.offsetHeight) !== null && _a !== void 0 ? _a : 5;
};
export var isOutsideOfContainer = function (e, treeBb) {
    return e.clientX < treeBb.left ||
        e.clientX > treeBb.right ||
        e.clientY < treeBb.top ||
        e.clientY > treeBb.bottom;
};
